<template>
	<el-main class="layout-chat-v2">
		<el-container>
			<layout-chat-left-v2
				@reloadList="loadChatList"
				:_chatList="chatList"
				:_chatingId.sync="chatingId"
				@createChat="createChat"
				:_onChatState="onChatState"
				:_creating="isCreatingChat"
			></layout-chat-left-v2>
			<layout-chat-main-v2
				:_chatObj="chatObj"
				:_chatDialogs="chatDialogs"
				:_dialogsLoading="dialogsLoading"
				@clearChatDialogs="clearChatDialogs"
				:_chatingId="chatingId"
				@changeOnChatState="changeOnChatState"
				@appendDialog="appendDialog"
				@updateLastDialog="updateLastDialog"
			></layout-chat-main-v2>
		</el-container>
	</el-main>
</template>

<script>
import LayoutChatLeftV2 from '@/views/app/layout-chat-v2/layout-chat-left-v2.vue';
import LayoutChatMainV2 from '@/views/app/layout-chat-v2/layout-chat-main-v2.vue';
import { createChat, getChatDialogs, getChatList, getNowChat } from '@/apis/chat';
import { Message } from 'element-ui';

export default {
	name: 'layout-chat-v2',
	components: { LayoutChatMainV2, LayoutChatLeftV2 },

	async mounted() {
		try {
			await this.loadChatList();
			if (this.chatList.length === 0) {
				await createChat();
				await this.loadChatList();
			}
			this.chatingId = await getNowChat();
		} catch (error) {
			// 列表读取失败不等于没有会话，不能因此再创建轮次。
			Message.error(error.message || '加载对话失败，请重新登录后重试');
		}
	},

	data() {
		return {
			chatList: [],
			chatingId: '',
			chatDialogs: [],
			onChatState: true,
			dialogsLoading: false,
			isCreatingChat: false,
		};
	},

	methods: {
		clearChatDialogs() {
			this.chatDialogs = [];
		},

		appendDialog(dialog) {
			this.chatDialogs.push(dialog);
		},

		updateLastDialog(patch) {
			const last = this.chatDialogs[this.chatDialogs.length - 1];
			if (last) {
				Object.assign(last, patch);
			}
		},

		async loadChatList() {
			this.chatList = await getChatList();
			this.chatList.forEach(item => {
				item.visible = true;
			});
		},

		async createChat() {
			// 防重入：创建是异步的（建轮次 + 刷列表），连点会建出多条轮次，进行中直接忽略后续点击
			if (this.isCreatingChat) return;
			this.isCreatingChat = true;
			try {
				await createChat();
				await this.loadChatList();
				if (this.chatList.length > 0) {
					this.chatingId = this.chatList[0].guid;
				}
		} catch (error) {
			// 创建失败时保留已有会话，避免把业务错误当作空列表。
			Message.error(error.message || '创建对话失败，请重新登录后重试');
			} finally {
				this.isCreatingChat = false;
			}
		},

		changeOnChatState(state) {
			this.onChatState = state;
		},
	},

	computed: {
		chatObj() {
			return this.chatList.find(item => item.guid === this.chatingId) || null;
		},
	},

	watch: {
		async chatingId(id) {
			// 不立即清空 chatDialogs：保留旧消息直到新数据到位，避免切换时的白屏闪烁。
			// 用 chatingId 自身做并发兜底——请求返回时若用户已切到别的轮次，丢弃本次结果。
			this.dialogsLoading = true;
			const requestedId = id;
			try {
				const chats = await getChatDialogs({ chatLunciGuid: id });
				if (this.chatingId !== requestedId) return;

				chats.forEach(item => {
					item.finished = true;
					if (item.chatRole === 'assistant') {
						if (item.contentType === 'img') {
							item.imgUrls = [item.chatContent];
							item.chatContent = '';
						}
						if (item.contentType === 'video') {
							item.videoUrls = [item.chatContent];
							item.chatContent = '';
						}
					}
					// 用户消息：把 DB 存储的 fileUrls 映射到 files，供气泡卡片回显
					if (item.chatRole === 'user' && Array.isArray(item.fileUrls) && item.fileUrls.length > 0) {
						item.files = item.fileUrls;

						// PHP 会把解析后的文件内容以 "\n\n【文件：xxx】\n..." 追加到 chat_content 并回写 DB，
						// 无论新旧格式，历史回显时都需要截取标记之前的部分，只展示用户输入的文字。
						const fileMarkerIdx = item.chatContent ? item.chatContent.indexOf('\n\n【文件：') : -1;
						item.displayContent = fileMarkerIdx >= 0
							? item.chatContent.slice(0, fileMarkerIdx).trim()
							: (item.chatContent || '');
					}
				});
				this.chatDialogs = chats;
			} catch (error) {
				if (this.chatingId === requestedId) {
					Message.error(error.message || '读取对话记录失败');
				}
			} finally {
				if (this.chatingId === requestedId) {
					this.dialogsLoading = false;
				}
			}
		},
	},
};
</script>

<style lang="scss">
.layout-chat-v2 {
	padding: 0 !important;
}
</style>
